import { ConfirmarSituacaoDialog } from "@/shared/components";
import styles from "./situacao-distribuicao-dialog.module.scss";
import type { SituacaoDistribuicaoDialogViewModel } from "./types-situacao-distribuicao-dialog";

export function SituacaoDistribuicaoDialogView({
  acao,
  titulo,
  subtitulo,
  oQueAcontece,
  confirmLabel,
  tituloEfeitos,
  identificacao,
  onConfirmar,
  onCancelar,
}: SituacaoDistribuicaoDialogViewModel) {
  return (
    <ConfirmarSituacaoDialog
      acao={acao}
      titulo={titulo}
      subtitulo={subtitulo}
      oQueAcontece={oQueAcontece}
      confirmLabel={confirmLabel}
      tituloEfeitos={tituloEfeitos}
      corpo={
        <div className={styles.identificacao} data-testid="situacao-distribuicao-identificacao">
          <p className={styles.intro}>{identificacao.intro}</p>
          <div className={styles.cartao}>
            <p className={styles.nome}>{identificacao.nome}</p>
            {identificacao.resumo.map((linha) => (
              <p key={linha} className={styles.resumo}>
                {linha}
              </p>
            ))}
          </div>
        </div>
      }
      onConfirmar={onConfirmar}
      onCancelar={onCancelar}
    />
  );
}
